import ListPayrolls from './views/List.vue'
import CreateEditPayroll from './views/CreateEdit.vue'
import GetPayroll from './views/Get.vue'

export const PayrollRoutes = [
  {
    path: '/payrolls',
    name: 'ListPayrolls',
    component: ListPayrolls,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'payroll:list'
    }
  },
  {
    path: '/payroll',
    name: 'CreatePayroll',
    component: CreateEditPayroll,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'payroll:create'
    }
  },
  {
    path: '/payroll/:id',
    name: 'UpdatePayroll',
    component: CreateEditPayroll,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'payroll:update'
    }
  },
  {
    path: '/payroll/view/:id',
    name: 'GetPayroll',
    component: GetPayroll,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'payroll:get'
    }
  }
]
